module.exports = __webpack_public_path__ + "static/media/video_5.911e0669.mp4";